import { Badge } from "@components/ui/badge";
import { Field, FieldGroup } from "@components/ui/field";
import AdCampaignFieldList from "@components/ads/forms/shared/AdCampaignFieldList";
import { useAssetForm } from "@components/ads/hooks/useAssetForm";
import { defaultAssetTransform } from "@components/ads/hooks";
import { Ads } from "@shared";
import InfoTooltip from "@components/ui/info-tooltip";
import RefreshSuggestionsButton from "../shared/RefreshSuggestionsButton";
import type { UpdateCampaignRequestBody } from "@rails_api_base";

export default function DescriptionsForm() {
  const { removeAsset, updateAsset, lockToggle, refreshAssets, fields, isPlaceholder, methods, control } =
    useAssetForm({
      assetKey: "descriptions",
      formGroup: "content",
      schema: Ads.DescriptionsFormSchema,
      transformFn: (data): Partial<UpdateCampaignRequestBody> | null => {
        const transformed = defaultAssetTransform(data.descriptions);
        if (transformed.length === 0) return null;
        return { descriptions: transformed };
      },
      refreshStage: "content",
    });

  return (
    <FieldGroup className="gap-3">
      <Field>
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <span className="font-semibold">Details</span>
            <InfoTooltip text="Details expand on your headlines. Describe what makes your business unique and why someone should click." />
          </div>
          <div className="flex items-center gap-2">
            <Badge variant="secondary">Select 2-4</Badge>
            <RefreshSuggestionsButton onClick={refreshAssets} />
          </div>
        </div>
      </Field>
      {methods.formState.errors.descriptions?.message && (
        <p className="text-sm text-red-500">{methods.formState.errors.descriptions.message as string}</p>
      )}
      <AdCampaignFieldList
        fieldName="descriptions"
        fields={fields as any}
        onLockToggle={lockToggle}
        onDelete={removeAsset}
        control={control as any}
        placeholder="Description Option"
        maxLength={90}
        onInputChange={updateAsset}
        isPlaceholder={isPlaceholder}
      />
    </FieldGroup>
  );
}
